"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var aes_1 = require("../aes");
var idb_1 = require("../idb");
var utils_1 = require("../utils");
var config_1 = require("../config");
var errors_1 = require("../errors");
var KeyStoreBase = /** @class */ (function () {
    function KeyStoreBase(cfg, store) {
        this.cfg = cfg;
        this.store = store;
    }
    KeyStoreBase.prototype.writeKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var maybeKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, idb_1.default.getKeypair(this.cfg.writeKeyName, this.store)];
                    case 1:
                        maybeKey = _a.sent();
                        return [2 /*return*/, errors_1.checkIsKeyPair(maybeKey)];
                }
            });
        });
    };
    KeyStoreBase.prototype.readKey = function () {
        return __awaiter(this, void 0, void 0, function () {
            var maybeKey;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, idb_1.default.getKeypair(this.cfg.readKeyName, this.store)];
                    case 1:
                        maybeKey = _a.sent();
                        return [2 /*return*/, errors_1.checkIsKeyPair(maybeKey)];
                }
            });
        });
    };
    KeyStoreBase.prototype.getSymmKey = function (keyName, cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var mergedCfg, maybeKey, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mergedCfg = config_1.default.merge(this.cfg, cfg);
                        return [4 /*yield*/, idb_1.default.getKey(keyName, this.store)];
                    case 1:
                        maybeKey = _a.sent();
                        if (maybeKey !== null) {
                            return [2 /*return*/, maybeKey];
                        }
                        return [4 /*yield*/, aes_1.default.makeKey(config_1.default.symmKeyOpts(mergedCfg))];
                    case 2:
                        key = _a.sent();
                        return [4 /*yield*/, idb_1.default.put(keyName, key, this.store)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, key];
                }
            });
        });
    };
    KeyStoreBase.prototype.keyExists = function (keyName) {
        return __awaiter(this, void 0, void 0, function () {
            var key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, idb_1.default.getKey(keyName, this.store)];
                    case 1:
                        key = _a.sent();
                        return [2 /*return*/, key !== null];
                }
            });
        });
    };
    KeyStoreBase.prototype.deleteKey = function (keyName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, idb_1.default.rm(keyName, this.store)];
            });
        });
    };
    KeyStoreBase.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, idb_1.default.dropStore(this.store)];
            });
        });
    };
    KeyStoreBase.prototype.importSymmKey = function (keyStr, keyName, cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var mergedCfg, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mergedCfg = config_1.default.merge(this.cfg, cfg);
                        return [4 /*yield*/, aes_1.default.importKey(keyStr, config_1.default.symmKeyOpts(mergedCfg))];
                    case 1:
                        key = _a.sent();
                        return [4 /*yield*/, idb_1.default.put(keyName, key, this.store)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    KeyStoreBase.prototype.exportSymmKey = function (keyName, cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSymmKey(keyName, cfg)];
                    case 1:
                        key = _a.sent();
                        return [2 /*return*/, aes_1.default.exportKey(key)];
                }
            });
        });
    };
    KeyStoreBase.prototype.encryptWithSymmKey = function (msg, keyName, cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var mergedCfg, key, cipherText;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mergedCfg = config_1.default.merge(this.cfg, cfg);
                        return [4 /*yield*/, this.getSymmKey(keyName, cfg)];
                    case 1:
                        key = _a.sent();
                        return [4 /*yield*/, aes_1.default.encryptBytes(utils_1.default.strToArrBuf(msg, mergedCfg.charSize), key, config_1.default.symmKeyOpts(mergedCfg))];
                    case 2:
                        cipherText = _a.sent();
                        return [2 /*return*/, utils_1.default.arrBufToBase64(cipherText)];
                }
            });
        });
    };
    KeyStoreBase.prototype.decryptWithSymmKey = function (cipherText, keyName, cfg) {
        return __awaiter(this, void 0, void 0, function () {
            var mergedCfg, key, msgBytes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        mergedCfg = config_1.default.merge(this.cfg, cfg);
                        return [4 /*yield*/, this.getSymmKey(keyName, cfg)];
                    case 1:
                        key = _a.sent();
                        return [4 /*yield*/, aes_1.default.decryptBytes(utils_1.default.base64ToArrBuf(cipherText), key, config_1.default.symmKeyOpts(mergedCfg))];
                    case 2:
                        msgBytes = _a.sent();
                        return [2 /*return*/, utils_1.default.arrBufToStr(msgBytes, mergedCfg.charSize)];
                }
            });
        });
    };
    return KeyStoreBase;
}());
exports.default = KeyStoreBase;
//# sourceMappingURL=base.js.map